<div id="kt_content" class="kt-content  kt-grid__item kt-grid__item--fluid">
  <div  class="kt-portlet kt-portlet--mobile">
      <div   class="kt-portlet__body">
          <div  class="kt-section">
              <div  class="kt-section__content">
                  <div  class="row col-lg-12">
                      <div  class="col-lg-5">
                          <div   class="kt-margin-b-20-tablet-and-mobile">
                              <div  class="kt-input-icon kt-input-icon&amp;#45;&amp;#45;left">
                                  <form >
                                      <div >
                                          <label> Search By Username:
                                              <input  type="text" class="form-control" style="width: 260px;">
                                          </label>
                                          <ul  id="autocomplete-results" class="autocomplete-results" style="display: none;"></ul>
                                      </div>
                                  </form>
                              </div>
                          </div>
                      </div>

                  </div>
              </div>
          </div>
      </div>
      <div  class="kt-portlet__body">
          <div  class="kt-section">
              <div  class="kt-section__content">
                  <div  class="table-responsive">
                      <table  class="table table-bordered table-hover table-striped">
                          <thead>
                              <tr>
                                  <th  class="text-center">No.</th>
                                  <th  class="text-center">Date</th>
                                  <th  class="text-center">Type</th>
                                  <th  class="text-center">Before</th>
                                  <th  class="text-center">Amount</th>
                                  <th  class="text-center">Bonus</th>
                                  <th  class="text-center">After</th>
                                  <th  class="text-center">Rollover Type</th>
                                  <th  class="text-center">Package Type</th>
                                  <th  class="text-center">Total Rollover</th>
                              </tr>
                          </thead>
                          <tbody>
                              <tr>
                                  <td  colspan="10" class="text-center">No records available in this date range</td>
                              </tr>
                          </tbody>
                      </table>
                  </div>
              </div>
          </div>
      </div>
  </div>
</div>
